import axios from "axios";
import { Global } from "../../config/global";
import { socketIsConnected } from "../../config/socket";  // Importar la función que verifica la conexión del socket

export const getChats = async ({ filter }) => { // Función para traer los chats.
    try {
        console.log("EN GETCHATS ISCONNECTEDSOCKET *-***********", socketIsConnected());
        let responseData = null;
        let idEmpresa = localStorage.getItem("idEmpresa"); // Extraer el id de la empresa.
        let token = localStorage.getItem('token'); // Extraer el token del localStorage.
        let headers = { // Definir el encabezado de la petición.
            Authorization: `Bearer ${token}`
        };

        // Definir el endpoint de la ruta y realizar la petición.
        let url = Global.url + `chat/${filter}/${idEmpresa}`; // Si no existe ningun valor de ultima posicion, se trata de una peticion de chats normales.

        if (socketIsConnected()) {
            console.log("el socket está conectado, y voy a traer los chats");
            responseData = await axios.get(url, { headers });
            console.log("dentro de getChats: CHATS ACTIVOS", responseData); 
            return responseData.data;
        } else {
            console.log("el socket NO está conectado, NO voy a traer los chats");
            return [];
        }

    } catch (error) {
        console.log(error);
        throw error;
    }
};
